/* Printora storefront behaviour (vanilla JS, no dependencies).
   Countdowns only count to real dates from Theme settings; nothing here invents stock, viewers or reviews. */
(function () {
  'use strict';
  var PR = window.PR || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var parse = function (x) { var v = Date.parse(x); return isNaN(v) ? 0 : v; };
  var pad = function (n) { return String(n).padStart(2, '0'); };

  /* ---------- time helpers (US Eastern) ---------- */
  function etParts(ms) {
    var o = {};
    try {
      new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', hour: 'numeric', minute: 'numeric', second: 'numeric', hourCycle: 'h23' })
        .formatToParts(new Date(ms)).forEach(function (p) { o[p.type] = +p.value || 0; });
    } catch (e) { var d = new Date(ms); o = { hour: d.getHours(), minute: d.getMinutes(), second: d.getSeconds() }; }
    return o;
  }
  function target(key) {
    if (key === 'midnight') {
      var now = Date.now(), p = etParts(now);
      return now + (86400 - (p.hour * 3600 + p.minute * 60 + p.second)) * 1000;
    }
    return parse({ bfStart: PR.bfStart, bfEnd: PR.bfEnd, xmasCut: PR.xmasCut }[key]);
  }
  function split(ms) {
    ms = Math.max(0, ms); var s = Math.floor(ms / 1000);
    return { d: Math.floor(s / 86400), h: Math.floor((s % 86400) / 3600), m: Math.floor((s % 3600) / 60), s: s % 60 };
  }

  /* ---------- countdowns ---------- */
  function buildCd(el) {
    var noDays = el.hasAttribute('data-hide-days');
    var units = noDays ? [['h', 'Hours'], ['m', 'Minutes'], ['s', 'Seconds']] : [['d', 'Days'], ['h', 'Hours'], ['m', 'Min'], ['s', 'Sec']];
    el.innerHTML = units.map(function (u, i) {
      return (i ? '<span class="pr-cd__sep" aria-hidden="true">:</span>' : '') +
        '<div class="pr-cd__u"><span class="pr-cd__n" data-u="' + u[0] + '">00</span><span class="pr-cd__l">' + u[1] + '</span></div>';
    }).join('');
    el.setAttribute('role', 'timer');
    el._units = units;
  }
  function tick() {
    var now = Date.now();
    $$('.pr-cd[data-cd]').forEach(function (el) {
      if (!el._units) buildCd(el);
      var t = target(el.getAttribute('data-cd'));
      var left = t - now;
      var wrap = el.closest('[data-cd-wrap]');
      if (!t || left <= 0) { if (wrap) wrap.hidden = true; return; }
      if (wrap) wrap.hidden = false;
      var v = split(left);
      el._units.forEach(function (u) { var n = el.querySelector('[data-u="' + u[0] + '"]'); if (n) n.textContent = pad(v[u[0]]); });
    });
    $$('.pr-cdi[data-cdi]').forEach(function (el) {
      var t = target(el.getAttribute('data-cdi')), left = t - now;
      var wrap = el.closest('[data-cd-wrap]');
      if (!t || left <= 0) { if (wrap) wrap.hidden = true; el.textContent = ''; return; }
      var v = split(left);
      el.textContent = (v.d ? v.d + 'd ' : '') + pad(v.h) + 'h ' + pad(v.m) + 'm ' + pad(v.s) + 's';
    });
  }

  /* ---------- delivery estimate (business days) ---------- */
  function addBD(ms, n) {
    var d = new Date(ms), k = 0;
    while (k < n) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) k++; }
    return d.getTime();
  }
  function fmt(ms, wd) {
    var o = { month: 'short', day: 'numeric' }; if (wd) o.weekday = 'short';
    try { return new Date(ms).toLocaleDateString('en-US', o); } catch (e) { return new Date(ms).toDateString(); }
  }
  function eta(country) {
    var now = Date.now(), prod = PR.prod || [2, 4];
    var ship = (country || PR.country) === 'US' ? (PR.ship && PR.ship.US) || [5, 7] : (PR.ship && PR.ship.WW) || [7, 15];
    return { today: fmt(now, true), printed: fmt(addBD(now, prod[1]), true), from: fmt(addBD(now, prod[0] + ship[0])), to: fmt(addBD(now, prod[1] + ship[1])) };
  }
  function setText(el, v) { if (el.textContent !== v) el.textContent = v; }
  function fillEta(root) {
    var e = eta(), us = eta('US');
    $$('[data-eta-range]', root).forEach(function (el) { setText(el, e.from + ' – ' + e.to); });
    $$('[data-eta-t2]', root).forEach(function (el) { setText(el, 'by ' + e.printed.replace(/^\w+, /, '')); });
    $$('[data-eta-t3]', root).forEach(function (el) { setText(el, e.from + ' – ' + e.to); });
    $$('[data-eta-step]', root).forEach(function (el) {
      var k = el.getAttribute('data-eta-step');
      setText(el, k === 'today' ? 'Order today, ' + us.today : k === 'printed' ? 'Printed by ' + us.printed : k === 'arrives' ? 'Arrives ' + us.from + ' – ' + us.to : '');
    });
    $$('[data-eta-line]', root).forEach(function (el) {
      var h = 'Order today and it should arrive between <b>' + us.from + '</b> and <b>' + us.to + '</b> in the United States.';
      if (el.innerHTML !== h) el.innerHTML = h;
    });
  }

  /* ---------- announcement ---------- */
  function initAnn() {
    $$('[data-pr-ann]').forEach(function (bar) {
      if (bar.__pr) return; bar.__pr = 1;
      var msgs = $$('.pr-ann__msg', bar).filter(function (m) {
        var s = m.getAttribute('data-season');
        return !s || s === 'all' || s === PR.current;
      });
      if (!msgs.length) { bar.hidden = true; return; }
      var i = 0;
      var show = function (d) { msgs[i].classList.remove('is-on'); i = (i + d + msgs.length) % msgs.length; msgs[i].classList.add('is-on'); };
      msgs[0].classList.add('is-on');
      $$('[data-ann-step]', bar).forEach(function (b) { b.hidden = msgs.length < 2; b.addEventListener('click', function () { show(+b.getAttribute('data-ann-step')); }); });
      if (msgs.length > 1) setInterval(function () { if (!bar.matches(':hover')) show(1); }, 5000);
    });
  }

  /* ---------- occasions ---------- */
  function initOcc() {
    $$('[data-pr-occ]').forEach(function (box) {
      var max = +box.getAttribute('data-max') || 8, now = Date.now(), shown = 0, first = true;
      $$('.pr-oc', box).forEach(function (a) {
        var d = a.getAttribute('data-date');
        if (shown >= max) { a.hidden = true; return; }
        if (d) {
          var t = parse(d + 'T23:59:59-05:00');
          if (!t || t < now) { a.hidden = true; return; }
          var days = Math.ceil((parse(d + 'T00:00:00-05:00') - now) / 864e5);
          var label = new Date(d + 'T12:00:00-05:00').toLocaleDateString('en-US', { month: 'short', day: 'numeric', timeZone: 'America/New_York' });
          $('.pr-oc__d', a).textContent = days <= 0 ? label + ' · today' : label + ' · in ' + days + ' day' + (days > 1 ? 's' : '');
          if (first) { var s = $('.pr-oc__soon', a); if (s) s.hidden = false; first = false; }
        }
        shown++;
      });
    });
  }

  /* ---------- product rail tabs ---------- */
  function initTabs() {
    $$('[data-pr-trend]').forEach(function (sec) {
      if (sec.__pr) return; sec.__pr = 1;
      var btns = $$('.pr-tabs [data-t]', sec);
      btns.forEach(function (b) {
        b.addEventListener('click', function () {
          var t = b.getAttribute('data-t');
          btns.forEach(function (x) { x.setAttribute('aria-pressed', x === b); });
          $$('.pr-card', sec).forEach(function (c) { c.hidden = !(t === 'all' || c.getAttribute('data-cat') === t); });
        });
      });
    });
  }

  /* ---------- money ---------- */
  function money(cents) {
    var f = PR.moneyFormat || '${{amount}}', v = (cents / 100);
    var withComma = function (x, dec, th, ds) { var p = x.toFixed(dec).split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th); return p.join(ds); };
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      if (k === 'amount_no_decimals') return withComma(v, 0, ',', '.');
      if (k === 'amount_with_comma_separator') return withComma(v, 2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return withComma(v, 0, '.', ',');
      return withComma(v, 2, ',', '.');
    });
  }

  /* ---------- cart: add items and open the drawer ---------- */
  function addToCart(items, btn) {
    var drawer = document.querySelector('cart-drawer');
    var body = { items: items };
    if (drawer && drawer.getSectionsToRender) {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    return fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (res.status && res.description) { alertMsg(btn, res.description); return; }
      if (drawer && res.sections) { drawer.classList.remove('is-empty'); drawer.renderContents(res); setTimeout(function () { fillEta(drawer); }, 50); }
      else window.location.href = (window.routes && window.routes.cart_url) || '/cart';
    }).catch(function () { window.location.href = (window.routes && window.routes.cart_url) || '/cart'; })
      .finally(function () { if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); } });
  }
  function alertMsg(btn, text) {
    if (!btn) return;
    var n = document.createElement('p'); n.className = 'pr-small'; n.style.color = 'var(--pr-berry)'; n.textContent = text;
    btn.parentNode.appendChild(n); setTimeout(function () { n.remove(); }, 4000);
  }
  document.addEventListener('submit', function (e) {
    var f = e.target.closest && e.target.closest('.pr-qa-form');
    if (!f) return;
    e.preventDefault();
    addToCart([{ id: +f.querySelector('[name="id"]').value, quantity: 1 }], f.querySelector('button'));
  });

  /* ---------- complete the gift ---------- */
  function initFbt() {
    $$('[data-pr-fbt]').forEach(function (box) {
      if (box.__pr) return; box.__pr = 1;
      var boxes = $$('input[data-fbt-id]', box), tot = $('[data-fbt-total]', box);
      var mainId = function () { var i = document.querySelector('form[action*="/cart/add"] input[name="id"]'); return i ? +i.value : 0; };
      var calc = function () {
        var s = 0; boxes.forEach(function (b) { if (b.checked) s += +b.getAttribute('data-fbt-price'); });
        if (tot) tot.textContent = money(s);
      };
      boxes.forEach(function (b) { b.addEventListener('change', calc); }); calc();
      var btn = $('[data-fbt-add]', box);
      if (btn) btn.addEventListener('click', function () {
        var items = boxes.filter(function (b) { return b.checked; }).map(function (b) {
          return { id: b.hasAttribute('data-fbt-main') ? (mainId() || +b.getAttribute('data-fbt-id')) : +b.getAttribute('data-fbt-id'), quantity: 1 };
        });
        if (items.length) addToCart(items, btn);
      });
    });
  }

  /* ---------- size guide ---------- */
  var SG = {
    sweat: [[20, 22, 24, 26, 28, 30], [27, 28, 29, 30, 31, 32], [33.5, 34.5, 35.5, 36.5, 37.5, 38.5], 'Sleeve (center back)'],
    tee: [[18, 20, 22, 24, 26, 28], [28, 29, 30, 31, 32, 33], [15.6, 17, 18.5, 20, 21.5, 22.9], 'Sleeve length'],
    hood: [[20, 22, 24, 26, 28, 30], [27, 28, 29, 30, 31, 32], [33.5, 34.5, 35.5, 36.5, 37.5, 38.5], 'Sleeve (center back)']
  };
  function initSG() {
    $$('[data-pr-sg]').forEach(function (box) {
      if (box.__pr) return; box.__pr = 1;
      var w = box.closest('[data-default]'); var type = (w && w.getAttribute('data-default')) || box.getAttribute('data-default') || 'sweat', unit = 'in';
      var tb = $('[data-sg-table] tbody', box);
      var render = function () {
        var d = SG[type], f = function (v) { return unit === 'in' ? v : Math.round(v * 2.54); };
        var row = function (lab, arr) { return '<tr><td>' + lab + '</td>' + arr.map(function (v) { return '<td>' + f(v) + '</td>'; }).join('') + '</tr>'; };
        tb.innerHTML = row('Chest width (flat)', d[0]) + row('Body length', d[1]) + row(d[3], d[2]);
      };
      var bind = function (sel, set) {
        var btns = $$(sel + ' [data-v]', box);
        btns.forEach(function (b) { b.addEventListener('click', function () { set(b.getAttribute('data-v')); btns.forEach(function (x) { x.setAttribute('aria-pressed', x === b); }); render(); }); });
      };
      bind('[data-sg-type]', function (v) { type = v; });
      bind('[data-sg-unit]', function (v) { unit = v; });
      var preset = $('[data-sg-type] [data-v="' + type + '"]', box); if (preset) preset.click(); else render();
    });
  }

  document.addEventListener('click', function (e) {
      var o = e.target.closest('[data-sg-open]');
      if (o) { var d = document.getElementById(o.getAttribute('data-sg-open')); if (d && d.showModal) { e.preventDefault(); d.showModal(); } }
      var c = e.target.closest('[data-sg-close]');
      if (c) { var dl = c.closest('dialog'); if (dl) dl.close(); }
      if (e.target.tagName === 'DIALOG' && e.target.classList.contains('pr-sgdlg')) e.target.close();
    });

  /* ---------- ornament personalization preview ---------- */
  var F = { d: 'Fraunces, Georgia, serif', b: 'Figtree, system-ui, sans-serif', s: 'Caveat, cursive' };
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function star4(x, y, r, fill) {
    var k = r * 0.18;
    return '<path d="M' + x + ',' + (y - r) + ' C' + (x + k * .3) + ',' + (y - k) + ' ' + (x + k) + ',' + (y - k * .3) + ' ' + (x + r) + ',' + y + ' C' + (x + k) + ',' + (y + k * .3) + ' ' + (x + k * .3) + ',' + (y + k) + ' ' + x + ',' + (y + r) + ' C' + (x - k * .3) + ',' + (y + k) + ' ' + (x - k) + ',' + (y + k * .3) + ' ' + (x - r) + ',' + y + ' C' + (x - k) + ',' + (y - k * .3) + ' ' + (x - k * .3) + ',' + (y - k) + ' ' + x + ',' + (y - r) + 'Z" fill="' + fill + '"/>';
  }
  function paw(x, y, s, fill) {
    return '<g transform="translate(' + x + ',' + y + ') scale(' + s + ')" fill="' + fill + '"><ellipse cx="0" cy="6" rx="9" ry="7.5"/><ellipse cx="-9" cy="-6" rx="3.6" ry="4.6"/><ellipse cx="-3.2" cy="-11" rx="3.6" ry="4.8"/><ellipse cx="3.2" cy="-11" rx="3.6" ry="4.8"/><ellipse cx="9" cy="-6" rx="3.6" ry="4.6"/></g>';
  }
  function ornText(key, name, year) {
    var nm = esc((name || '').slice(0, 14) || ' '), yr = esc((year || '').slice(0, 4));
    var t = function (y, fam, size, fill, txt, extra) { return '<text x="0" y="' + y + '" font-family="' + fam + '" font-size="' + size + '" text-anchor="middle" fill="' + fill + '" ' + (extra || '') + '>' + txt + '</text>'; };
    if (key === 'together') return t(-40, F.s, 26, '#B8322A', 'Our First Christmas', 'font-weight="700"') + t(12, F.d, nm.length > 9 ? 32 : 42, '#1E2320', nm, 'font-style="italic" font-weight="500"') + t(46, F.b, 16, '#B8322A', yr, 'font-weight="700" letter-spacing="6"');
    if (key === 'pet') return paw(0, -66, 1.3, '#B8322A') + t(-22, F.s, 24, '#2F6B4A', 'forever in our hearts', 'font-weight="700"') + t(24, F.d, nm.length > 8 ? 38 : 50, '#1E2320', nm, 'font-style="italic" font-weight="500"') + t(60, F.b, 15, '#2F6B4A', 'EST. ' + yr, 'font-weight="700" letter-spacing="4"');
    if (key === 'family') return '<g transform="translate(0,-66)" fill="none" stroke="#2F6B4A" stroke-width="3" stroke-linejoin="round"><path d="M-22,10 L0,-12 L22,10 L22,26 L-22,26 Z"/><path d="M-6,26 L-6,14 L6,14 L6,26"/></g>' + t(0, F.d, nm.length > 10 ? 32 : 40, '#B8322A', nm, 'font-style="italic" font-weight="500"') + t(34, F.b, 15, '#2F6B4A', 'EST. ' + yr, 'font-weight="700" letter-spacing="5"') + t(72, F.s, 26, '#1E2320', 'merry christmas', 'font-weight="700"');
    return star4(0, -84, 9, '#C9A45C') + t(-48, F.s, 28, '#2F6B4A', "Baby's First Christmas", 'font-weight="700"') + t(12, F.d, nm.length > 8 ? 40 : 52, '#B8322A', nm, 'font-style="italic" font-weight="500"') + t(52, F.b, 17, '#2F6B4A', yr, 'font-weight="700" letter-spacing="6"');
  }
  var uid = 0;
  function ornament(key, name, year, shape) {
    var g = 'pro' + (++uid), heart = shape === 'heart';
    var lights = [[60, 70, 26], [330, 110, 34], [80, 380, 30], [350, 400, 22], [290, 40, 18], [40, 230, 16]].map(function (l) { return '<circle cx="' + l[0] + '" cy="' + l[1] + '" r="' + l[2] + '" fill="url(#' + g + 'l)"/>'; }).join('');
    var needles = ''; for (var i = 0; i < 26; i++) { var x = -10 + i * 17, y = 30 + Math.sin(i * .7) * 5; needles += '<path d="M' + x + ',' + y + ' l-10,-16 M' + x + ',' + y + ' l10,-15 M' + x + ',' + y + ' l-12,12 M' + x + ',' + y + ' l12,13"/>'; }
    var hp = 'M200,392 C150,352 84,306 84,236 C84,196 114,166 150,166 C174,166 192,178 200,196 C208,178 226,166 250,166 C286,166 316,196 316,236 C316,306 250,352 200,392Z';
    var body = heart ? '<path d="' + hp + '" fill="url(#' + g + 'c)"/><path d="' + hp + '" fill="none" stroke="#000" stroke-opacity=".08" stroke-width="2"/>' : '<circle cx="200" cy="268" r="124" fill="url(#' + g + 'c)"/><circle cx="200" cy="268" r="124" fill="none" stroke="#000" stroke-opacity=".08" stroke-width="2"/>';
    var holeY = heart ? 186 : 158, dy = heart ? 262 : 272;
    return '<svg viewBox="0 0 400 480" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice" role="img" aria-label="Ornament preview"><defs>' +
      '<radialGradient id="' + g + 'l"><stop offset="0" stop-color="#F6D38B" stop-opacity=".55"/><stop offset="1" stop-color="#F6D38B" stop-opacity="0"/></radialGradient>' +
      '<radialGradient id="' + g + 'c" cx=".36" cy=".3" r=".85"><stop offset="0" stop-color="#FFFFFF"/><stop offset=".6" stop-color="#F6F2EA"/><stop offset="1" stop-color="#DDD5C6"/></radialGradient>' +
      '<linearGradient id="' + g + 'r" x1="0" x2="1"><stop offset="0" stop-color="#8E1F22"/><stop offset=".5" stop-color="#C8352E"/><stop offset="1" stop-color="#8E1F22"/></linearGradient>' +
      '<filter id="' + g + 'f" x="-30%" y="-30%" width="160%" height="160%"><feDropShadow dx="0" dy="14" stdDeviation="14" flood-color="#000" flood-opacity=".35"/></filter>' +
      '<filter id="' + g + 'b"><feGaussianBlur stdDeviation="6"/></filter></defs>' +
      '<rect width="400" height="480" fill="#0B3326"/><g filter="url(#' + g + 'b)">' + lights + '</g>' +
      '<g stroke="#07231A" stroke-width="3.2" stroke-linecap="round">' + needles + '</g><path d="M-10,32 C120,24 260,40 410,28" stroke="#3B2A1E" stroke-width="7" fill="none" stroke-linecap="round"/>' +
      '<path d="M194,34 L196,' + holeY + ' M206,34 L204,' + holeY + '" stroke="url(#' + g + 'r)" stroke-width="5" fill="none" stroke-linecap="round"/>' +
      '<g filter="url(#' + g + 'f)">' + body + '</g><circle cx="200" cy="' + holeY + '" r="6" fill="#B9AF9E"/>' +
      '<g transform="translate(200,' + dy + ') scale(' + (heart ? .82 : .92) + ')">' + ornText(key, name, year) + '</g>' +
      '<ellipse cx="150" cy="' + (heart ? 214 : 196) + '" rx="38" ry="18" fill="#fff" opacity=".5" transform="rotate(-30 150 200)" filter="url(#' + g + 'b)"/></svg>';
  }
  function initPers() {
    $$('[data-pr-pers]').forEach(function (sec) {
      if (sec.__pr) return; sec.__pr = 1;
      var st = { d: 'baby', shape: 'round' };
      var prev = $('[data-pers-prev]', sec), nm = $('[data-pers-name]', sec), yr = $('[data-pers-year]', sec);
      var defaults = { baby: 'Emma', together: 'Mr & Mrs', pet: 'Max', family: 'The Carters' };
      var draw = function () { prev.innerHTML = ornament(st.d, nm.value, yr.value, st.shape); };
      var group = function (sel, key, after) {
        var btns = $$(sel + ' [data-v]', sec);
        btns.forEach(function (b) { b.addEventListener('click', function () { st[key] = b.getAttribute('data-v'); btns.forEach(function (x) { x.setAttribute('aria-pressed', x === b); }); if (after) after(); draw(); }); });
      };
      group('[data-pers-design]', 'd', function () { nm.value = defaults[st.d]; });
      group('[data-pers-shape]', 'shape');
      nm.addEventListener('input', draw); yr.addEventListener('input', draw);
      draw();
    });
  }

  /* ---------- personalization fields join the product form ---------- */
  function initPersFields() {
    $$('[data-pr-pers-fields]').forEach(function (box) {
      var sec = box.closest('section') || document;
      var form = sec.querySelector('form[id^="product-form-"]') || document.querySelector('form[id^="product-form-"]');
      if (!form) return;
      $$('input', box).forEach(function (i) { i.setAttribute('form', form.id); });
    });
  }

  /* ---------- boot ---------- */
  function boot() {
    initAnn(); initOcc(); initTabs(); initFbt(); initSG(); initPers(); initPersFields();
    fillEta(document); tick(); setInterval(tick, 1000);
    var cd = document.querySelector('cart-drawer');
    if (cd && window.MutationObserver) new MutationObserver(function () { fillEta(cd); }).observe(cd, { childList: true, subtree: true });
    var cart = document.querySelector('#main-cart-footer');
    if (cart && window.MutationObserver) new MutationObserver(function () { fillEta(cart); }).observe(cart, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function () { initAnn(); initOcc(); initTabs(); initFbt(); initSG(); initPers(); fillEta(document); tick(); });
})();
